export default __webpack_public_path__ + "static/media/ro.346f1bc1.svg";